export default {
  TAB: 'tab',
  CATEGORY: 'category',
  TITLE: 'title',
  DESCRIPTION: 'description',
  LINK: 'link',
  PERMISSIONS: 'permissions'
};
